import { Content } from '@/types';
import CarouselView from '../carousel-view/CarouselView';
import GridView from '../grid-view/GridView';
import ListView from '../list-view/ListView';

interface Props {
  type: 'list' | 'grid' | 'carousel';
  data: Content[];
  previewWidget: string;
}

const ViewSwitcher = ({ data = [], type = 'list', previewWidget }: Props) => {
  switch (type) {
    case 'list':
      return (
        <ListView items={data} previewWidget={previewWidget} />
      );
    case 'grid':
      return <GridView items={data} previewWidget={previewWidget} />;
    case 'carousel':
      return <CarouselView items={data} previewWidget={previewWidget} />;
    default:
      return null;
  }
};

export default ViewSwitcher;
